import React from "react";
import { Link } from "react-router-dom";
import knackvibeslogo from "../assets/images/knackvibe.png"
const ContactUs = () => {
  return (
    <div className="container mt-5 ">
             <div style={{ display: 'flex', alignItems: 'center',marginBottom:30 }}>
          <Link to="/AiResumeInsights">
            <i className="fa  fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
          </Link>
          <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Contact Us</h2>
        </div>
        <hr/>
      <div className="row mt-3" style={{height:800}}>
        {/* Contact Card 1 */}
        <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12">
          <div
            className="card shadow-lg"
            style={{ border: "none", borderRadius: "20px", background: "#fff" }}
          >
            <div className="card-body">

<div className="text-center">
<a target="_blank" href="https://knackhire.azurewebsites.net/">
<img src="https://assessnhiredev.azurewebsites.net/static/media/knackhire-new.fe8d9b9e9acf584d2427.png" style={{height:'50px'}}className="img-fluid"/>
</a>
  </div>      
  <p className=" m-0 mt-3" style={{color:'#000',fontSize:'17px'}}>
  KnackHire is an AI-powered, all-in-one staffing solution that streamlines job and candidate management, resume parsing, and AI-driven matching. It offers advanced video and coding assessments, submission tracking, and facilitates seamless client, vendor, and team collaboration for efficient hiring.
  </p>            
  <h5 style={{color:'#00a7ac',marginTop:'30px',textAlign:'center',marginBottom:'30px',fontWeight:'600'}}>Core Features</h5>

       <ul className="mt-4" style={{color:'#000',fontSize:'17px'}}>
        <li>Job & candidate management, resume parsing, AI matching.</li>
        <li>AI-powered video & coding tests, submission tracking</li>
        <li>Client & vendor management, team collaboration, lead management.</li>
       </ul>
  <div className="address p-2 d-flex align-items-center mt-5" style={{marginTop:'60px'}}>
                <i
                  className="fa fa-map-marker  mr-3"
                  style={{ fontSize: "17px", color: "#00a7ac",color:'#00a7ac' }}
                ></i>
                <p className="m-0" style={{color:'#000',fontSize:'17px'}}>
                1420 156TH AVE NE SUITE F,
                BELLEVUE, WA 98007-4421.
                </p>
              </div>
              <div className="email p-2 d-flex align-items-center">
                <i
                  className="fa fa-envelope mr-3"
                  style={{ fontSize: "17px", color: "#00a7ac" }}
                ></i>
                <p className=" m-0" style={{color:'#000',fontSize:'17px'}}>
                  
                hire@knackhook.com
                  
                </p>
              </div>
              <div className="phone p-2 d-flex align-items-center">
                <i
                  className="fa fa-phone  mr-3"
                  style={{ fontSize: "17px", color: "#00a7ac" }}
                ></i>
                <p className=" m-0" style={{color:'#000',fontSize:'17px'}}> +1 (425) 548-6321</p>
              </div>
              <div className="phone p-2 d-flex align-items-center">
              <i
  className="fa fa-globe  mr-3"
  style={{ fontSize: "17px", color: "#00a7ac" }}
></i>

<a target="_blank" href="https://knackhire.azurewebsites.net/"> <p className=" m-0" style={{color:'#000',fontSize:'17px'}}>
  
                https://knackhire.azurewebsites.net/</p></a>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Card 2 */}
        <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12">
          <div
            className="card shadow-lg"
            style={{ border: "none", borderRadius: "20px", background: "#fff" }}
          >
            <div className="card-body">

<div className="text-center">
  
<a target="_blank" href="https://knackvibes.ai/">
  <img src={knackvibeslogo} style={{height:'50px'}}className="img-fluid"/>
 </a> </div>  
 <p className=" m-0 mt-3" style={{color:'#000',fontSize:'17px'}}>
 KnackVibes is an AI-powered personal branding tool that enhances LinkedIn presence with AI-based content generation, automated post scheduling, and intelligent engagement tracking. It also supports social media branding agencies by managing multiple clients on a single platform.
  </p>
  <h5 style={{color:'#00a7ac',marginTop:'30px',textAlign:'center',marginBottom:'30px',fontWeight:'600'}}>Core Features</h5>

  <ul className="mt-4" style={{color:'#000',fontSize:'17px'}}>
        <li>AI-driven content generation and scheduling
        </li>
        <li>Intelligent engagement tracking and analytics</li>
        <li>Multi-client management for agencies with centralized control</li>
       </ul>
       
  <div className="address p-2 d-flex align-items-center" style={{marginTop:'80px'}}>
                <i
                  className="fa fa-map-marker  mr-3"
                  style={{ fontSize: "17px", color: "#00a7ac"}}
                ></i>
                <p className="m-0" style={{color:'#000',fontSize:'17px'}}>
                1420 156TH AVE NE SUITE F,
                BELLEVUE, WA 98007-4421.
                </p>
              </div>
              <div className="email p-2 d-flex align-items-center">
                <i
                  className="fa fa-envelope mr-3"
                  style={{ fontSize: "17px", color: "#00a7ac" }}
                ></i>
                <p className=" m-0" style={{color:'#000',fontSize:'17px'}}>
                  
                vibes@knackhook.com
                  
                </p>
              </div>
              <div className="phone p-2 d-flex align-items-center">
                <i
                  className="fa fa-phone  mr-3"
                  style={{ fontSize: "17px", color: "#00a7ac" }}
                ></i>
                <p className=" m-0" style={{color:'#00o',fontSize:'17px'}}> +1 (425) 548-6321</p>
              </div>
              <div className="phone p-2 d-flex align-items-center">
              <i
  className="fa fa-globe  mr-3"
  style={{ fontSize: "17px", color: "#00a7ac" }}
></i>

<a target="_blank" href="https://knackvibes.ai/"> <p className=" m-0" style={{color:'#000',fontSize:'17px'}}>
https://knackvibes.ai/</p></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
